import { render } from "./CCWidget.vue?vue&type=template&id=04ba7553&scoped=true"
import script from "./CCWidget.vue?vue&type=script&lang=js"
export * from "./CCWidget.vue?vue&type=script&lang=js"

import "./CCWidget.vue?vue&type=style&index=0&id=04ba7553&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ba7553"]])

export default __exports__